import CollectionAvatar from "./collection-avatar";

export default CollectionAvatar;